import get from 'lodash/get';
import {
  NEW_INVOICES_QTY,
  NEW_DOWNLOADS_QTY,
  NEW_XML_QTY,
  NEW_REMINDERS_QTY,
  NEW_ROLE,
  NEW_PLAN,
  NEW_PACKAGE_STATS,
  PURGE_PACKAGES,
  NEW_USERS,
} from '../actions/permsActions';

import {
  FOLIOS,
  DOWNLOADS,
  SMS,
  USERS,
  CUSTOMERS,
  EMAILS,
  CREDITS,
  STRIPE,
  STP,
  OXXO,
  CONEKTA,
  FISERV,
  CONTPAQI,
  TAX_STAMPS,
  EXPORT_DATA,
  ACCOUNT_STATEMENT,
  ADD_USER,
  BRANDING,
  ADD_CUSTOMERS,
  ADD_CREDITS,
  API,
  WHATSAPP,
  WHATSAPP_ACTIVE,
  VOICE_AGENT,
  VOICE_AGENT_ACTIVE,
  ASSISTANT_TOKENS,
  ASSISTANT_SAVED_QUERIES,
} from '../../constants/subscriptions';

const initialState = {
  user_perms: { role: 1, plan: 1 },
  users: { admin: [], users: [] },
  adons: {
    [STRIPE]: null,
    [STP]: null,
    [OXXO]: null,
    [CONEKTA]: null,
    [FISERV]: null,
    [CONTPAQI]: null,
    [TAX_STAMPS]: null,
    [EXPORT_DATA]: null,
    [ACCOUNT_STATEMENT]: null,
    [ADD_USER]: null,
    [BRANDING]: null,
    [ADD_CUSTOMERS]: null,
    [ADD_CREDITS]: null,
    [API]: null,
    [WHATSAPP_ACTIVE]: null,
    [VOICE_AGENT_ACTIVE]: null
  },
  packages: {
    [FOLIOS]: null,
    [DOWNLOADS]: null,
    [SMS]: null,
    [USERS]: null,
    [CUSTOMERS]: null,
    [EMAILS]: null,
    [WHATSAPP]: null,
    [VOICE_AGENT]: null,
    [ASSISTANT_TOKENS]: null,
    [ASSISTANT_SAVED_QUERIES]: null,
  },
  [CREDITS]: null
};

const parsePayloadPackage = (payload = []) => {
  if (!Array.isArray(payload)) {
    return initialState.packages;
  }

  const packages = [FOLIOS, DOWNLOADS, SMS, USERS, CUSTOMERS, EMAILS, WHATSAPP, VOICE_AGENT, ASSISTANT_TOKENS, ASSISTANT_SAVED_QUERIES];
  const initialReduceValue = initialState.packages;

  return payload.reduce((previousValue, currentValue) => {
    const keyName = get(currentValue, 'key_name');

    if (!packages.includes(keyName)) {
      return previousValue;
    }

    return {
      ...previousValue,
      [keyName]: currentValue
    };
  }, initialReduceValue);
};

const parsePayloadAdons = (payload = []) => {
  if (!Array.isArray(payload)) {
    return initialState.adons;
  }

  const adons = [
    STRIPE,
    STP,
    OXXO,
    CONEKTA,
    FISERV,
    CONTPAQI,
    TAX_STAMPS,
    EXPORT_DATA,
    ACCOUNT_STATEMENT,
    ADD_USER,
    BRANDING,
    ADD_CUSTOMERS,
    ADD_CREDITS,
    API,
    WHATSAPP_ACTIVE,
    VOICE_AGENT_ACTIVE
  ];

  const initialReduceValue = initialState.adons;

  return payload.reduce((previousValue, currentValue) => {
    const keyName = get(currentValue, 'key_name');

    if (!adons.includes(keyName)) {
      return previousValue;
    }

    return {
      ...previousValue,
      [keyName]: currentValue
    };
  }, initialReduceValue);
};

const parsePayloadCredits = (payload = []) => {
  if (!Array.isArray(payload)) {
    return initialState[CREDITS];
  }

  return payload.find(value => value.key_name === CREDITS)
};

export default function (state = initialState, action) {
  let { payload, type } = action,
    newState;
  switch (type) {
    case PURGE_PACKAGES:
      newState = { ...initialState, ...{ user_perms: state.user_perms } };
      return { ...state, ...newState };

    case NEW_PACKAGE_STATS:
      newState = {
        user_perms: state.user_perms,
        users: state.users,
        packages: parsePayloadPackage(payload),
        adons: parsePayloadAdons(payload),
        credits: parsePayloadCredits(payload)
      };
      return { ...state, ...newState };

    case NEW_USERS:
      newState = { users: payload };
      return { ...state, ...newState };

    case NEW_INVOICES_QTY:
      newState = { folios_total: payload };
      return { ...state, ...newState };

    case NEW_DOWNLOADS_QTY:
      newState = { downloads_total: payload };
      return { ...state, ...newState };

    case NEW_XML_QTY:
      newState = { xml_imports_total: payload };
      return { ...state, ...newState };

    case NEW_REMINDERS_QTY:
      newState = { automatic_reminder_total: payload };
      return { ...state, ...newState };

    case NEW_PLAN:
      newState = { user_perms: { role: state.user_perms.role, plan: payload } };
      return { ...state, ...newState };

    case NEW_ROLE:
      newState = { user_perms: { role: payload, plan: state.user_perms.plan } };
      return { ...state, ...newState };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/permsReducer.js